import {Component, Input} from '@angular/core';
import {StudyBundleCourseDto} from '../../shared/types/StudyBundleCourseDto';

@Component({
  selector: 'lp2-speechace-tile',
  templateUrl: './speechace-tile.component.html',
  styleUrls: ['./speechace-tile.component.scss']
})
export class SpeechaceTileComponent {
  @Input() speechace: StudyBundleCourseDto = <StudyBundleCourseDto>{};

  constructor() { }
}



// WEBPACK FOOTER //
// ./ts/app/home/speechace-tile/speechace-tile.component.ts